module.exports = __webpack_public_path__ + "static/img/btn1.bafa77d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn1.png
// module id = yu8o
// module chunks = 1